import { createOptionsFrom } from "@/lib/common/Option";

export const PerformanceDeltaSortLabels = {
	PercentageGain: "Percentage Gain",
	PercentageLoss: "Percentage Loss",
	FlatGain: "Flat Gain",
	FlatLoss: "Flat Loss",
	HighestSales: "Highest Sales"
} as const;

export type PerformanceDeltaSort = keyof typeof PerformanceDeltaSortLabels;

export const PerformanceDeltaSortOptions = createOptionsFrom(PerformanceDeltaSortLabels);
